import gql from 'graphql-tag'

export default gql`query getPage ($id: Int!) {
	getPage(id: $id) {
		id
		type
    img_header_desktop
    img_header_mobile
		details {
			id
			title
			content
			language_code
      meta_title
      meta_description
      meta_tags
      meta_og_title
      meta_og_description
      meta_og_url
		}
	}
}
`



// WEBPACK FOOTER //
// ./src/apollo/graphql/page/get.js